import apiClient from '@/services/api';
import { useAuthStore } from '@/stores/auth';

const API_URL = '/employees';

const sanitizeEmployeeData = (employeeData) => {
  const data = { ...employeeData }; // Create a shallow copy to avoid mutating original
  const authStore = useAuthStore();
  data.company_id = data.company_id || authStore.currentUser?.company_id;

  // Normalise enums to backend's exact casing
  if (data.status) data.status = data.status.toLowerCase();   // active | inactive …

  return data;
};

export default {
  async getEmployees() {
    const authStore = useAuthStore();
    const userCompanyId = authStore.currentUser?.company_id;
    
    // Build URL with company filter if user has a company_id
    let url = '/employees';
    if (userCompanyId) {
      const filter = {"field":"company_id","value":userCompanyId};
      url += `?filter=${encodeURIComponent(JSON.stringify(filter))}`;
    }
    
    return (await apiClient.get(url)).data;
  },
  async getEmployee(id)           { const r = await apiClient.get(`${API_URL}/${id}`); return r.data; },
  async createEmployee(data)      { const r = await apiClient.post(API_URL, sanitizeEmployeeData(data)); return r.data; },
  async updateEmployee(id, data)  { const r = await apiClient.put(`${API_URL}/${id}`, sanitizeEmployeeData(data)); return r.data; },
  async deleteEmployee(id)        { return apiClient.delete(`${API_URL}/${id}`); }
};
